import { render, staticRenderFns } from "./VqTextarea.vue?vue&type=template&id=597ea278&scoped=true&lang=html&"
import script from "./VqTextarea.vue?vue&type=script&lang=js&"
export * from "./VqTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ea278",
  null
  
)

export default component.exports